import { render, staticRenderFns } from "./SearchWrapper.vue?vue&type=template&id=6541a329&scoped=true&"
import script from "./SearchWrapper.vue?vue&type=script&lang=js&"
export * from "./SearchWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SearchWrapper.vue?vue&type=style&index=0&id=6541a329&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6541a329",
  null
  
)

export default component.exports